import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { NavigateFunction } from "react-router-dom";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { AdsStatementPageControllerImpl, AdsStrings } from "../../../business";
import { AdsStatementDataResponse } from "../../interfaces";
import { AdsStatementPageFactoryImpl } from "../factories";

interface IAdsPage {
    navigate: NavigateFunction,
}

export const AdsStatementPage: React.FC<IAdsPage> = ({ navigate }) => {
    const strings = AdsStrings['PTBR'].statement;
    const [isLoading, setLoading] = useState<Boolean>(true);
    const [plansData, setPlansData] = useState<AdsStatementDataResponse>();

    const factory = new AdsStatementPageFactoryImpl();
    const controller = new AdsStatementPageControllerImpl();

    const fetchData = async () => {
        try {
            const response = await controller.onLoad();
            setLoading(false);
            setPlansData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const content =
        <> <h4 className="mb-4">{strings.title}</h4>
            <Card>
                <Card.Body>
                    {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(plansData)}
                </Card.Body>
            </Card>
        </>

    return <AdmPanelContainer children={content} />
}
